import { render, staticRenderFns } from "./youxiangDesk.vue?vue&type=template&id=1c565110&scoped=true&"
import script from "./youxiangDesk.vue?vue&type=script&lang=js&"
export * from "./youxiangDesk.vue?vue&type=script&lang=js&"
import style0 from "./youxiangDesk.vue?vue&type=style&index=0&id=1c565110&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c565110",
  null
  
)

export default component.exports